import {
    get_annotazioniMezzo,
    create_annotazioneMezzo,
    update_annotazioneMezzo,
    elimina_annotazioneMezzo,
} from "@/api/api.annotazionemezzo.js";

const annotazioniMezzo = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_annotazioniMezzo(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati, mezzoId }) {
            const call = id ? update_annotazioneMezzo(id, dati) : create_annotazioneMezzo(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica", { mezzoId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, { id, mezzoId }) {
            return new Promise((resolve, reject) => {
                elimina_annotazioneMezzo(id).then(resp => {
                    dispatch("carica", { mezzoId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default annotazioniMezzo;
